import React, { ReactElement, useEffect, useState } from 'react';
import './nhcxUserCreation.less';
import { Button, Col, Form, Row, Statistic } from 'antd';
import FormOTPInput from '../../../shared/components/crmFormElement/FormOTPInput/FormOTPInput';
import NhcxSuccessModal from './NhcxSuccessModal';
import { confirmParticipantDetails, rollOutPayersForNHCX, saveParticipantDetails, setShowOtpScreen, updateCertificates } from '../../../store/actions/nhcxAction';
import { useDispatch } from 'react-redux';
import { ReactComponent as EditIcon } from '../../../assets/images/svg/Edit-icon.svg';
import { NHCX_REGISTRIES, NHCX_ROLES, VALIDATE_MESSAGES } from '../../../shared/constants/commonConstants';
import { centeredNotification } from '../../../utils/utility';

const NhcxUserCreation = ({ showOtpFlow, formValues, timelineItems, otpCallback, trnsactionId,
    userCreation, participantID, setTrnsactionId }: any): ReactElement => {
    const [otpForm] = Form.useForm();
    const [resend, setResend] = useState(0);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showOtp, setShowOtp] = useState(false);
    const [showRetry, setShowRetry] = useState(false);
    const [isInvalid, setIsInvalid] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [isConfirmClicked, setIsConfirmClicked] = useState(false);
    const [showBtn, setShowBtn] = useState(true);
    const [loading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const deadline = Date.now() + 301000;
    const Countdown = Statistic.Countdown;

    const onConfirm = (): any => {
        const formValue = {
            otp: otpForm?.getFieldValue(['otp']),
            transactionId: trnsactionId,
        };
        setIsLoading(true);
        dispatch(confirmParticipantDetails(formValue, onSuccess, onError));
    };

    useEffect((): any => {
        if (isConfirmClicked) {
            otpCallback(otpForm?.getFieldValue(['otp']), isInvalid, isConfirmClicked);
        }
    }, [isConfirmClicked]);
    const onSuccess = (message: any): any => {
      setIsLoading(false);
      setIsConfirmClicked(true);
      setShowSuccessModal(true);
      dispatch(updateCertificates(participantID));
      dispatch(rollOutPayersForNHCX());
    };

    const onError = (error: any): any => {
        setIsLoading(false);
        setIsInvalid(true);
        setShowSuccessModal(false);
        centeredNotification(error);
        setIsConfirmClicked(false);
    };
    const onValueChange = (): any => {
        if (otpForm?.getFieldValue(['otp'])) {
            otpCallback(otpForm?.getFieldValue(['otp']), isInvalid, isConfirmClicked);
        }
        if (otpForm?.getFieldValue(['otp'])?.length === 6) {
            setShowBtn(false);
        } else {
            setShowBtn(true);
        }
    };
    const onFinish = (): any => {
        setResend((prevState: any): any => prevState);
        setShowRetry(false);
    };
    const payload = {
        registryType: NHCX_ROLES?.PROVIDER,
        role: NHCX_REGISTRIES?.HFR,
        email: userCreation?.getFieldValue(['email']),
        mobileNumber: userCreation?.getFieldValue(['mobileNumber'])?.replace(/\s+/g, ''),
        registryid: userCreation?.getFieldValue(['hfrId']),
    };
    const resendComponent = (resend === 0 && showOtp && !showRetry) ? <p className="resend-link text-underline font-12"
        onClick={(): any => { setShowRetry(true); dispatch(saveParticipantDetails(payload, onSaveSuccess)); }}>
        Send Again </p> : <Countdown value={deadline} format="mm:ss" onFinish={onFinish} />;

    const sendPasscode = (): any => {
        setShowOtp(true);
        setShowEdit(true);
    };

    const onSaveSuccess = (transactionid: any, message: any, participantid: any): any => {
        centeredNotification(message, 'success');
        setTrnsactionId(transactionid);
    };

    const onClickBack = (): any => {
        dispatch(setShowOtpScreen(false));
        otpForm?.setFieldsValue({ otp: otpForm?.getFieldValue(['otp']) });
    };

    return (
        <>
            <NhcxSuccessModal showSuccessModal={showSuccessModal} setShowSuccessModal={setShowSuccessModal} />
            <div className="user-creation-cont w-70">
                <span className="ml-32">Participant Creation Confirmation</span>
                <div className="user-creation w-50">
                    <p className="details p-ml-10">
                        Enter the passcode received on <b className="bold">
                            <span className="italic">+91 </span>{formValues?.getFieldValue(['mobileNumber'])}</b>
                        {(showEdit) && <span className="edit"><EditIcon onClick={(): any => dispatch(setShowOtpScreen(false))} /></span>}
                    </p>
                    <Row>
                        <Form validateMessages={VALIDATE_MESSAGES}>
                            <Col md={24} className="col-flex mb-30">
                                <FormOTPInput
                                    autoFocus={true}
                                    length={6}
                                    className="nhcx-otp-cont"
                                    inputClassName={`${isInvalid ? 'red-color nhcxotpInput' : 'nhcxotpInput'} nhcxotpInput`}
                                    form={otpForm}
                                    onChangeOTP={onValueChange}
                                    onFocus={(e: any): any => {
                                        e?.target?.classList?.add('purple-border');
                                        if (!e?.target?.value?.length) {
                                            e?.target?.classList.remove('black-border');
                                        }
                                    }} onBlur={(e: any): any => {
                                        if (!e?.target?.value?.length) {
                                            e?.target?.classList?.add('black-border');
                                            e?.target?.classList?.remove('purple-border');
                                        } else {
                                            e?.target?.classList?.add('purple-border');
                                            e?.target?.classList?.remove('black-border');
                                        }
                                        if (otpForm?.getFieldValue(['otp'])?.length === 6) {
                                            timelineItems?.map((item: any): any => {
                                                if (item?.icon?.props?.children === 4) {
                                                    return { ...item, completed: true };
                                                }
                                                return item;
                                            });
                                        }
                                    }}
                                    onChange={(e: any): any => {
                                        if (e?.target?.value?.length) {
                                            e?.target?.classList?.add('purple-border');
                                            e?.target?.classList?.remove('black-border');
                                        } else {
                                            e?.target?.classList?.remove('purple-border');
                                            e?.target?.classList?.add('black-border');
                                        }
                                    }}
                                />
                            </Col>
                            <Col className={!showOtp ? 'ml-10' : ''}>
                                <div className={` ${!showOtp ? 'ml-password' : ''} ${isInvalid ? 'm-top-70' : 'm-top-60'} passcode-text-container`}>
                                    {!isInvalid ? (!showOtp) ? <p className="resend-link-text text-underline text-right"
                                        onClick={sendPasscode}> Didn't receive the passcode?</p> :
                                        <p>Didn't receive the passcode?</p> : <></>}
                                    {(showOtp) && <><p className="passcode-text">
                                        Please ensure that your entered mobile number matches the<br /> one registered with HFR</p>
                                        <p className="otp-component-text otp-cont ml-25">
                                            {(resend === 0 && showOtp && showRetry) && (
                                                <React.Fragment>
                                                    <b className="font-12">{'Retry in'}</b>&nbsp;
                                                </React.Fragment>
                                            )}
                                            {resendComponent}

                                        </p></>}
                                </div>
                            </Col>
                            <div className={`${!showOtp ? 'ml-45' : ''} btn`}>
                                <Button className="ghost-primary-btn no-border bold width-100"
                                    type="ghost" size="middle" onClick={onClickBack}>Back</Button>
                                <Button className="l-10 nxt-btn confirm-width-100" type="primary" size="middle"
                                    onClick={onConfirm} loading={loading} disabled={showBtn}>Confirm</Button>
                            </div>
                        </Form>
                    </Row>
                </div>
            </div>
        </>
    );
};
export default NhcxUserCreation;
